import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

//解决路由重复报错问题 push、replace
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch((err) => err);
};

const routes = [
    // {
    //     path:'/',
    //     redirect:'/index',
    // },
     // CY096故障码
    {
        path: '/index',
        name: 'index',
        component: () => import('../pages/index.vue'),
        meta:{keepAlive:false}
    },
    // V321测试报告
    {
        path: '/report',
        name: 'report',
        component: () => import('../pages/report.vue'),
        meta:{keepAlive:false}
    },
    //V901测试报告
    {
        path: '/V901',
        name: 'V901',
        component: () => import('../pages/V901.vue'),
        meta:{keepAlive:false}
    },
    //V529测试报告 接口传的是V901
    {
        path: '/V529',
        name: 'V529',
        component: () => import('../pages/V529.vue'),
        meta:{keepAlive:false}
    },
    //V529测试报告新的 接口传的是V529
    {
        path: '/faultReport',
        name: 'faultReport',
        component: () => import('../pages/faultReport.vue'),
        meta:{keepAlive:false}
    },
    //V902AI测试报告
    {
        path: '/AIreport',
        name: 'AIreport',
        component: () => import('../pages/AIstreaming.vue'),
        meta:{keepAlive:false}
    },
    //M200 故障码AI测试报告
    {
        path: '/AIAgent',
        name: 'AIAgent',
        component: () => import('../pages/AIAgent.vue'),
        meta:{keepAlive:false}
    },
    //V106故障码
    {
        path:'/faultCode',
        name:'faultCode',
        component: () => import('../pages/faultCode.vue'),
        meta:{keepAlive:false}
    },
    //CY124
    {
        path:'/conference',
        name:'conference',
        component: () => import('../pages/CY124.vue'),
        meta:{keepAlive:false}
    },
    //故障码
    
    {
        path:'/dtc',
        name:'dtc',
        component: () => import('../pages/dtc.vue'),
        meta:{keepAlive:false}
    },
    {
        path:'/DataDtc',
        name:'DataDtc',
        component: () => import('../pages/DataDtc.vue'),
        meta:{keepAlive:false}
    },
    //冻结帧
    {
        path:'/freeze',
        name:'freeze',
        component: () => import('../pages/freeze.vue'),
        meta:{keepAlive:false}
    },
    //冻结帧
    {
        path:'/DataFreeze',
        name:'DataFreeze',
        component: () => import('../pages/DataFreeze.vue'),
        meta:{keepAlive:false}
    },
    //数据流(有参考值功能)
    {
        path:'/data',
        name:'data',
        component: () => import('../pages/data.vue'),
        meta:{keepAlive:false}
    },
    //数据流(没有参考值功能)
    {
        path:'/DataStream',
        name:'DataStream',
        component: () => import('../pages/DataStream.vue'),
        meta:{keepAlive:false}
    }
]
const router = new Router({
    mode:'hash',
    routes
})

export default router;